import { render } from "./MerchantForm.vue?vue&type=template&id=3c48da3d&scoped=true"
import script from "./MerchantForm.vue?vue&type=script&lang=js"
export * from "./MerchantForm.vue?vue&type=script&lang=js"

import "./MerchantForm.vue?vue&type=style&index=0&id=3c48da3d&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c48da3d"]])

export default __exports__